import { MouseEvent } from 'react'
import arrowRightIcon from '@assets/images/arrow-right.svg'
import {
  GridActionsCellItem,
  GridCellParams,
  GridColDef,
} from '@microservices/wiskey-react-table-component'
import { ContentCopy, Delete, Download, Edit, Preview, Send } from '@mui/icons-material'

import { CustomSvgIcon } from '@components/CustomSvgIcon'

import { DEFAULT_HEADER_STYLES_CLASSNAME } from '@constants'

type HandlerActionClick = (
  params: GridCellParams<any, any, any>,
  event: MouseEvent<HTMLButtonElement>
) => void

type DataGridActionsColumnParams = {
  onCopy?: HandlerActionClick
  onEdit?: HandlerActionClick
  onAdditionalButtonClick?: HandlerActionClick
  onDowloadButtonClick?: HandlerActionClick
  onPreviewButtonClick?: HandlerActionClick
  onDelete?: HandlerActionClick
  onRowButtonClick?: HandlerActionClick
  isDialogWindow?: boolean
  columnDef?: GridColDef
  activeDownloadRows?: Record<string, boolean>
}

export const generateDataGridActionsColumn = ({
  onCopy,
  onEdit,
  onAdditionalButtonClick,
  onDowloadButtonClick,
  onPreviewButtonClick,
  onRowButtonClick,
  onDelete,
  isDialogWindow,
  columnDef,
  activeDownloadRows,
}: DataGridActionsColumnParams): GridColDef => {
  return {
    field: 'actions',
    type: 'actions',
    align: 'right',
    // minWidth: onCopy ? 150 : 100,
    minWidth:
      [
        onCopy,
        onAdditionalButtonClick,
        onEdit,
        onDelete,
        onDowloadButtonClick,
        onPreviewButtonClick,
        onRowButtonClick,
      ].filter(Boolean).length * 40,
    resizable: false,
    hideable: false,
    headerClassName: `${DEFAULT_HEADER_STYLES_CLASSNAME}`,
    // pinnedColumn: PINNED_COLUMN.RIGHT, // Для промежуточных расчётов. Не влияет на реальное закрепление.
    getActions: (params: GridCellParams) =>
      [
        onCopy ? (
          <GridActionsCellItem
            key={params.id}
            icon={<ContentCopy />}
            label={'Copy'}
            showInMenu={false}
            onClick={event => {
              event.stopPropagation()
              onCopy?.(params, event)
            }}
          />
        ) : null,
        onEdit ? (
          <GridActionsCellItem
            key={params.id}
            icon={<Edit />}
            label={'Edit'}
            showInMenu={false}
            onClick={event => {
              event.stopPropagation()
              onEdit?.(params, event)
            }}
          />
        ) : null,
        onDelete ? (
          <GridActionsCellItem
            key={params.id}
            icon={<Delete />}
            label={'Delete'}
            showInMenu={false}
            onClick={event => {
              event.stopPropagation()
              onDelete?.(params, event)
            }}
          />
        ) : null,
        onPreviewButtonClick ? (
          <GridActionsCellItem
            key={params.id}
            icon={<Preview />}
            label='Preview'
            showInMenu={false}
            onClick={event => {
              event.stopPropagation()
              onPreviewButtonClick?.(params, event)
            }}
          />
        ) : null,
        onDowloadButtonClick ? (
          <GridActionsCellItem
            key={params.id}
            disabled={activeDownloadRows?.[params.row.id]}
            icon={<Download />}
            label={'Download'}
            showInMenu={false}
            onClick={event => {
              event.stopPropagation()
              onDowloadButtonClick?.(params, event)
            }}
          />
        ) : null,
        onAdditionalButtonClick ? (
          <GridActionsCellItem
            key={params.id}
            // TODO Сейчас иконка хардкод. В дальнейшем админ должен сам выбрать нужную иконку
            icon={<Send />}
            label={'Edit'}
            showInMenu={false}
            onClick={event => {
              event.stopPropagation()
              onAdditionalButtonClick?.(params, event)
            }}
          />
        ) : null,
        onRowButtonClick ? (
          <CustomSvgIcon
            key={params.id}
            fontSize={isDialogWindow ? 'small' : 'medium'}
            src={arrowRightIcon}
            onClick={event => {
              event.stopPropagation()
              onRowButtonClick?.(params, event)
            }}
          />
        ) : null,
      ].filter(Boolean),
    ...columnDef,
  } as GridColDef
}
